<div class="flex items-center gap-3 bg-main text-white pb-4 px-6 rounded-t">
  <span mat-dialog-title class="text-[1.15rem] font-bold tracking-[0.2px] !p-0 !m-0 text-white">
    {{ messages.title | translateProp }}
  </span>
</div>

<mat-dialog-content class="!pt-5 max-h-[70vh] overflow-y-auto">
  <p class="mb-4 text-gray-700 leading-[1.65] text-[0.95rem]">
    <em>{{ messages.introHighlight | translateProp }}</em>
    {{ messages.intro | translateProp }}
  </p>

  <div class="bg-subtitles border-l-4 border-main rounded-md py-3 px-[14px] mb-3">
    <span class="block font-bold text-main text-sm uppercase tracking-[0.5px] mb-2">
      {{ messages.quickWay | translateProp }}
    </span>
    <div class="flex items-center flex-wrap gap-2 mb-2">
      <div
        class="inline-flex items-center gap-[5px] bg-white border-[1.5px] border-main rounded-lg py-1.5 px-3 shadow-[0_1px_4px_rgba(36,83,105,0.15)]"
      >
        <kbd class="kbd-key">Ctrl</kbd>
        <span class="text-main font-bold text-base leading-none">+</span>
        <kbd class="kbd-key">F5</kbd>
      </div>
      <span class="text-gray-400 text-[0.8rem] italic">/ macOS:</span>
      <div
        class="inline-flex items-center gap-[5px] bg-white border-[1.5px] border-main rounded-lg py-1.5 px-3 shadow-[0_1px_4px_rgba(36,83,105,0.15)]"
      >
        <kbd class="kbd-key">⌘</kbd>
        <span class="text-main font-bold text-base leading-none">+</span>
        <kbd class="kbd-key">Shift</kbd>
        <span class="text-main font-bold text-base leading-none">+</span>
        <kbd class="kbd-key">R</kbd>
      </div>
    </div>
    <p class="!mt-1 !text-gray-500 !text-[0.8rem] leading-normal">
      {{ messages.ctrlF5Hint | translateProp }}
    </p>
  </div>

  <div class="bg-ground border-l-4 border-brand rounded-md py-3 px-[14px] mb-3">
    <span class="block font-bold text-main text-sm uppercase tracking-[0.5px] mb-2">
      {{ messages.ifPersists | translateProp }}
    </span>
    <p class="mt-1.5 leading-normal text-gray-700 text-sm">
      {{ messages.clearCacheInstructions | translateProp }}
    </p>
  </div>

  <p class="text-[0.86rem] text-gray-500 my-2 leading-normal">📱 {{ messages.mobileHint | translateProp }}</p>

  <details class="cache-tip mt-[10px] text-[0.84rem] text-gray-500 border-t border-dashed border-gray-300 pt-[10px]">
    <summary class="cursor-pointer text-main font-medium select-none hover:underline">
      {{ messages.cacheLabel | translateProp }}
    </summary>
    <p class="mt-2 leading-[1.55] pl-3 border-l-2 border-gray-200">
      {{ messages.cacheExplain | translateProp }}
    </p>
  </details>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="close()">{{ messages.actionUnderstood | translateProp }}</button>
  <button mat-flat-button color="primary" class="bg-main inline-flex items-center gap-1.5" (click)="reloadPage()">
    <mat-icon class="icon-xs">refresh</mat-icon>
    {{ messages.actionReload | translateProp }}
  </button>
</mat-dialog-actions>
